/**
 * 번역 필요성 게이트 (Phase 2)
 *
 * "이 메시지가 내 언어인가?"를 비율로 판정한다 — 상대 언어를 분석하지 않고,
 * 내 언어(ko/ja/en) 문자 비율이 임계 미만이면 번역 대상으로 본다.
 * 인사/고유명사 혼용(소량 섞임)은 무시하고 "본문이 내 언어인가"를 본다.
 */

export type TransLang = 'ko' | 'ja' | 'en';

/** i18n.locale → 번역 타겟 언어 (ko/ja/en 외는 en 취급) */
export function toTransLang(locale: string | undefined): TransLang {
  return locale === 'ko' ? 'ko' : locale === 'ja' ? 'ja' : 'en';
}

/** 내 언어 문자 비율이 이 값 미만이면 번역 (인사·고유명사 혼용 무시) */
const THRESHOLD = 0.4;

export function needsTranslation(text: string | undefined | null, myLang: TransLang): boolean {
  if (!text) return false;
  const clean = text.replace(/https?:\/\/\S+/g, '').replace(/@\S+/g, '');

  const hangul = (clean.match(/[가-힣]/g) || []).length;
  const kana   = (clean.match(/[ぁ-ヿ]/g) || []).length;   // 히라가나+가타카나
  const cjk    = (clean.match(/[一-鿿]/g) || []).length;   // 한자
  const latin  = (clean.match(/[a-zA-Z]/g) || []).length;
  const total  = hangul + kana + cjk + latin;
  if (total === 0) return false;                            // 이모지·숫자뿐 → 스킵

  const mine = myLang === 'ko' ? hangul
             : myLang === 'ja' ? kana + cjk
             : latin;
  return mine / total < THRESHOLD;
}
